var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 130,
    viewBox: "0 0 108 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0775 0H99.6925V8.1H83.0775V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4626 16.2V8.1H83.0775V16.2H66.4626Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8476 24.3V16.2H66.4626V24.3H49.8476Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2326 32.4V24.3H49.8476V32.4H33.2326Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9251 97.2V32.4H33.2326V97.2H24.9251Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31018 105.3H24.9251V97.2H8.31018V105.3Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2326 121.5V129.6H8.31018V121.59L0.0026937 121.592L0 105.301L8.31018 105.3V121.5H33.2326Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5401 113.4V121.5H33.2326V113.4H41.5401Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8476 48.6V113.4H41.5401V48.6H49.8476Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4626 40.5V48.6H49.8476V40.5H66.4626Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0775 40.5H66.4626V32.4H83.0775V40.5Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0775 81V40.5H91.385V81H83.0775Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4626 89.1V81H83.0775V89.1H66.4626Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4626 105.3H58.1551V89.1H66.4626V105.3Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.385 105.3V113.4H66.4626V105.3H91.385Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6925 97.2V105.3H91.385V97.2H99.6925Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6925 97.2H108V8.1H99.6925V97.2Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1129 39.8057H82.8656V31.4743H66.371V39.8057H49.8765V48.1371H41.6292V114.789H33.382V123.12H8.64014V106.457H25.1347V98.1257H33.382V31.4743H49.8765V23.1428H66.371V14.8114H82.8656V6.47998H99.3601V98.1257H91.1129V106.457H66.371V89.7943H82.8656V81.4628H91.1129V39.8057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOn);
export default __webpack_public_path__ + "static/media/music_on.40129cf734f50f1a5fd5f6f5a085e55e.svg";
export { ForwardRef as ReactComponent };